// Auto-generated from live backend: http://erp-taxis-be:8080/api/permissions
// Generated at: 2026-10-06T17:16:31.296Z
// Do not edit directly. Run 'bun run sync:perms' to update.

export const PERMISSIONS = {
  ACUERDOS_PAGO_CREATE: 'acuerdos_pago.create',
  ACUERDOS_PAGO_DELETE: 'acuerdos_pago.delete',
  ACUERDOS_PAGO_READ: 'acuerdos_pago.read',
  ACUERDOS_PAGO_UPDATE: 'acuerdos_pago.update',
  ADMIN_BYPASS: 'admin.bypass',
  AUDIT_READ: 'audit.read',
  BALANCE_PRUEBA_READ: 'balance_prueba.read',
  BANCO_MAPPING_CREATE: 'banco_mapping.create',
  BANCO_MAPPING_DELETE: 'banco_mapping.delete',
  BANCO_MAPPING_READ: 'banco_mapping.read',
  BANCO_MAPPING_UPDATE: 'banco_mapping.update',
  BATCH_JOBS_CREATE: 'batch_jobs.create',
  BATCH_JOBS_DELETE: 'batch_jobs.delete',
  BATCH_JOBS_READ: 'batch_jobs.read',
  BATCH_JOBS_UPDATE: 'batch_jobs.update',
  CARGOS_CREATE: 'cargos.create',
  CARGOS_DELETE: 'cargos.delete',
  CARGOS_DOCUMENT_READ: 'cargos.document.read',
  CARGOS_DOCUMENT_SIGN: 'cargos.document.sign',
  CARGOS_READ: 'cargos.read',
  CARGOS_UPDATE: 'cargos.update',
  CARGOS_VOID: 'cargos.void',
  CENTROS_COSTO_CREATE: 'centros_costo.create',
  CENTROS_COSTO_DELETE: 'centros_costo.delete',
  CENTROS_COSTO_READ: 'centros_costo.read',
  CENTROS_COSTO_UPDATE: 'centros_costo.update',
  CIERRES_BYPASS: 'cierres.bypass',
  CIERRES_READ: 'cierres.read',
  CIERRES_UPDATE: 'cierres.update',
  CITAS_TALLER_CREATE: 'citas_taller.create',
  CITAS_TALLER_DELETE: 'citas_taller.delete',
  CITAS_TALLER_READ: 'citas_taller.read',
  CITAS_TALLER_UPDATE: 'citas_taller.update',
  CLIENTES_CREATE: 'clientes.create',
  CLIENTES_DELETE: 'clientes.delete',
  CLIENTES_READ: 'clientes.read',
  CLIENTES_UPDATE: 'clientes.update',
  COMPRAS_PAGOS_UPDATE: 'compras_pagos.update',
  COMPROMISO_LLAMADAS_CREATE: 'compromiso_llamadas.create',
  COMPROMISO_LLAMADAS_DELETE: 'compromiso_llamadas.delete',
  COMPROMISO_LLAMADAS_READ: 'compromiso_llamadas.read',
  COMPROMISO_LLAMADAS_UPDATE: 'compromiso_llamadas.update',
  CONTRATOS_CREATE: 'contratos.create',
  CONTRATOS_DELETE: 'contratos.delete',
  CONTRATOS_DOCUMENT_READ: 'contratos.document.read',
  CONTRATOS_DOCUMENT_SIGN: 'contratos.document.sign',
  CONTRATOS_READ: 'contratos.read',
  CONTRATOS_REVERTIR_CIERRE: 'contratos.revertir_cierre',
  CONTRATOS_UPDATE: 'contratos.update',
  COSTOS_EXPORT: 'costos.export',
  COSTOS_READ: 'costos.read',
  CUENTAS_BANCO_CREATE: 'cuentas_banco.create',
  CUENTAS_BANCO_DELETE: 'cuentas_banco.delete',
  CUENTAS_BANCO_READ: 'cuentas_banco.read',
  CUENTAS_BANCO_UPDATE: 'cuentas_banco.update',
  CUENTAS_PUC_CREATE: 'cuentas_puc.create',
  CUENTAS_PUC_DELETE: 'cuentas_puc.delete',
  CUENTAS_PUC_READ: 'cuentas_puc.read',
  CUENTAS_PUC_UPDATE: 'cuentas_puc.update',
  DASHBOARD_READ: 'dashboard.read',
  DIAS_NO_PAGOS_CREATE: 'dias_no_pagos.create',
  DIAS_NO_PAGOS_DELETE: 'dias_no_pagos.delete',
  DIAS_NO_PAGOS_READ: 'dias_no_pagos.read',
  DIAS_NO_PAGOS_UPDATE: 'dias_no_pagos.update',
  DIAS_NO_PAGOS_VOID: 'dias_no_pagos.void',
  DOCUMENTS_CREATE: 'documents.create',
  DOCUMENTS_DELETE: 'documents.delete',
  DOCUMENTS_READ: 'documents.read',
  DOCUMENTS_UPDATE: 'documents.update',
  ENTREGAS_CLASSIFY_UNIDENTIFIED: 'entregas.classify_unidentified',
  ENTREGAS_CLOSE: 'entregas.close',
  ENTREGAS_CREATE: 'entregas.create',
  ENTREGAS_DELETE: 'entregas.delete',
  ENTREGAS_MODULE_READ: 'entregas.module.read',
  ENTREGAS_READ: 'entregas.read',
  ENTREGAS_UPDATE: 'entregas.update',
  ENTREGAS_VOID: 'entregas.void',
  EXCEPCIONES_CREATE: 'excepciones.create',
  EXCEPCIONES_DELETE: 'excepciones.delete',
  EXCEPCIONES_READ: 'excepciones.read',
  EXCEPCIONES_UPDATE: 'excepciones.update',
  FACTURAS_COMPRA_APPROVE: 'facturas_compra.approve',
  FACTURAS_COMPRA_CREATE: 'facturas_compra.create',
  FACTURAS_COMPRA_DELETE: 'facturas_compra.delete',
  FACTURAS_COMPRA_READ: 'facturas_compra.read',
  FACTURAS_COMPRA_UPDATE: 'facturas_compra.update',
  FESTIVOS_CREATE: 'festivos.create',
  FESTIVOS_DELETE: 'festivos.delete',
  FESTIVOS_READ: 'festivos.read',
  FESTIVOS_UPDATE: 'festivos.update',
  GASTOS_CLOSE: 'gastos.close',
  GASTOS_CREATE: 'gastos.create',
  GASTOS_DELETE: 'gastos.delete',
  GASTOS_READ: 'gastos.read',
  GASTOS_UPDATE: 'gastos.update',
  GASTOS_VOID: 'gastos.void',
  GASTOS_MACROS_CREATE: 'gastos_macros.create',
  GASTOS_MACROS_DELETE: 'gastos_macros.delete',
  GASTOS_MACROS_READ: 'gastos_macros.read',
  GASTOS_MACROS_UPDATE: 'gastos_macros.update',
  GASTOS_TIPOS_CREATE: 'gastos_tipos.create',
  GASTOS_TIPOS_DELETE: 'gastos_tipos.delete',
  GASTOS_TIPOS_READ: 'gastos_tipos.read',
  GASTOS_TIPOS_UPDATE: 'gastos_tipos.update',
  HORAS_TALLER_CREATE: 'horas_taller.create',
  HORAS_TALLER_DELETE: 'horas_taller.delete',
  HORAS_TALLER_READ: 'horas_taller.read',
  HORAS_TALLER_UPDATE: 'horas_taller.update',
  INGRESOS_GENERALES_READ: 'ingresos_generales.read',
  INGRESOS_NETOS_TAXI_READ: 'ingresos_netos_taxi.read',
  INV_CONSUMOS_APPROVE: 'inv_consumos.approve',
  INV_CONSUMOS_CREATE: 'inv_consumos.create',
  INV_CONSUMOS_DELETE: 'inv_consumos.delete',
  INV_CONSUMOS_READ: 'inv_consumos.read',
  INV_CONSUMOS_UPDATE: 'inv_consumos.update',
  INV_DESPACHOS_APPROVE: 'inv_despachos.approve',
  INV_DESPACHOS_CREATE: 'inv_despachos.create',
  INV_DESPACHOS_DELETE: 'inv_despachos.delete',
  INV_DESPACHOS_READ: 'inv_despachos.read',
  INV_DESPACHOS_UPDATE: 'inv_despachos.update',
  INV_KARDEX_READ: 'inv_kardex.read',
  INV_SALDOS_READ: 'inv_saldos.read',
  KITS_PRODUCTOS_CREATE: 'kits_productos.create',
  KITS_PRODUCTOS_DELETE: 'kits_productos.delete',
  KITS_PRODUCTOS_READ: 'kits_productos.read',
  KITS_PRODUCTOS_UPDATE: 'kits_productos.update',
  MAYOR_JERARQUICO_READ: 'mayor_jerarquico.read',
  ORDENES_SERVICIO_CREATE: 'ordenes_servicio.create',
  ORDENES_SERVICIO_DELETE: 'ordenes_servicio.delete',
  ORDENES_SERVICIO_MATERIALIZE: 'ordenes_servicio.materialize',
  ORDENES_SERVICIO_READ: 'ordenes_servicio.read',
  ORDENES_SERVICIO_UPDATE: 'ordenes_servicio.update',
  PLANILLAS_CREATE: 'planillas.create',
  PLANILLAS_DELETE: 'planillas.delete',
  PLANILLAS_READ: 'planillas.read',
  PLANILLAS_UPDATE: 'planillas.update',
  PRESTAMOS_CREATE: 'prestamos.create',
  PRESTAMOS_DELETE: 'prestamos.delete',
  PRESTAMOS_READ: 'prestamos.read',
  PRESTAMOS_UPDATE: 'prestamos.update',
  PRODUCTOS_CREATE: 'productos.create',
  PRODUCTOS_DELETE: 'productos.delete',
  PRODUCTOS_READ: 'productos.read',
  PRODUCTOS_UPDATE: 'productos.update',
  PROVEEDORES_CREATE: 'proveedores.create',
  PROVEEDORES_DELETE: 'proveedores.delete',
  PROVEEDORES_READ: 'proveedores.read',
  PROVEEDORES_UPDATE: 'proveedores.update',
  RESPONSABLES_CONSUMO_CREATE: 'responsables_consumo.create',
  RESPONSABLES_CONSUMO_DELETE: 'responsables_consumo.delete',
  RESPONSABLES_CONSUMO_READ: 'responsables_consumo.read',
  RESPONSABLES_CONSUMO_UPDATE: 'responsables_consumo.update',
  ROLES_CREATE: 'roles.create',
  ROLES_DELETE: 'roles.delete',
  ROLES_READ: 'roles.read',
  ROLES_UPDATE: 'roles.update',
  SALDOS_DIARIO_READ: 'saldos_diario.read',
  SALDOS_RENTA_READ: 'saldos_renta.read',
  SALDOS_RESUMEN_READ: 'saldos_resumen.read',
  SEGMENTOS_CREATE: 'segmentos.create',
  SEGMENTOS_DELETE: 'segmentos.delete',
  SEGMENTOS_READ: 'segmentos.read',
  SEGMENTOS_UPDATE: 'segmentos.update',
  SEGUIMIENTO_CARTERA_READ: 'seguimiento_cartera.read',
  SINIESTRO_CREATE: 'siniestro.create',
  SINIESTRO_DELETE: 'siniestro.delete',
  SINIESTRO_READ: 'siniestro.read',
  SINIESTRO_UPDATE: 'siniestro.update',
  SOLICITUD_DIAS_NO_PAGOS_APPROVE: 'solicitud_dias_no_pagos.approve',
  SOLICITUD_DIAS_NO_PAGOS_CREATE: 'solicitud_dias_no_pagos.create',
  SOLICITUD_DIAS_NO_PAGOS_DELETE: 'solicitud_dias_no_pagos.delete',
  SOLICITUD_DIAS_NO_PAGOS_GENERATE: 'solicitud_dias_no_pagos.generate',
  SOLICITUD_DIAS_NO_PAGOS_PREAPPROVE: 'solicitud_dias_no_pagos.preapprove',
  SOLICITUD_DIAS_NO_PAGOS_READ: 'solicitud_dias_no_pagos.read',
  SOLICITUD_DIAS_NO_PAGOS_REJECT: 'solicitud_dias_no_pagos.reject',
  SOLICITUD_DIAS_NO_PAGOS_UPDATE: 'solicitud_dias_no_pagos.update',
  TES_CIERRE_CAJA_CREATOR_PRIVILEGED: 'tes_cierre_caja.creator_privileged',
  TES_CIERRE_CAJA_READ: 'tes_cierre_caja.read',
  TES_CIERRE_CAJA_VIEW_NON_PRIVILEGED: 'tes_cierre_caja.view_non_privileged',
  TES_CLASIFICACION_CREATE: 'tes_clasificacion.create',
  TES_CLASIFICACION_DELETE: 'tes_clasificacion.delete',
  TES_CLASIFICACION_READ: 'tes_clasificacion.read',
  TES_CLASIFICACION_UPDATE: 'tes_clasificacion.update',
  TES_CONCILIACION_EXPORT: 'tes_conciliacion.export',
  TES_CONCILIACION_READ: 'tes_conciliacion.read',
  TES_CONCILIACION_UPDATE: 'tes_conciliacion.update',
  TES_MOVIMIENTOS_APPROVE: 'tes_movimientos.approve',
  TES_MOVIMIENTOS_CREATE: 'tes_movimientos.create',
  TES_MOVIMIENTOS_DELETE: 'tes_movimientos.delete',
  TES_MOVIMIENTOS_EXPORT: 'tes_movimientos.export',
  TES_MOVIMIENTOS_READ: 'tes_movimientos.read',
  TES_MOVIMIENTOS_UPDATE: 'tes_movimientos.update',
  TES_MOVIMIENTOS_VIEW_ALL: 'tes_movimientos.view_all',
  TES_MOVIMIENTOS_VOID: 'tes_movimientos.void',
  TES_RECAUDO_BANCOS_READ: 'tes_recaudo_bancos.read',
  TES_SALDOS_DIARIOS_CREATE: 'tes_saldos_diarios.create',
  TES_SALDOS_DIARIOS_DELETE: 'tes_saldos_diarios.delete',
  TES_SALDOS_DIARIOS_READ: 'tes_saldos_diarios.read',
  TES_SALDOS_DIARIOS_UPDATE: 'tes_saldos_diarios.update',
  TES_TIPO_PAGO_CREATE: 'tes_tipo_pago.create',
  TES_TIPO_PAGO_DELETE: 'tes_tipo_pago.delete',
  TES_TIPO_PAGO_READ: 'tes_tipo_pago.read',
  TES_TIPO_PAGO_UPDATE: 'tes_tipo_pago.update',
  USUARIOS_CREATE: 'usuarios.create',
  USUARIOS_PASSWORD_RESET: 'usuarios.password.reset',
  USUARIOS_READ: 'usuarios.read',
  USUARIOS_UPDATE: 'usuarios.update',
  VEHICULOS_CREATE: 'vehiculos.create',
  VEHICULOS_DELETE: 'vehiculos.delete',
  VEHICULOS_READ: 'vehiculos.read',
  VEHICULOS_UPDATE: 'vehiculos.update',
  YARD_CATALOG_CREATE: 'yard_catalog.create',
  YARD_CATALOG_DELETE: 'yard_catalog.delete',
  YARD_CATALOG_READ: 'yard_catalog.read',
  YARD_CATALOG_UPDATE: 'yard_catalog.update',
  YARD_CONTROL_CREATE: 'yard_control.create',
  YARD_CONTROL_DELETE: 'yard_control.delete',
  YARD_CONTROL_READ: 'yard_control.read',
  YARD_CONTROL_UPDATE: 'yard_control.update',
  YARD_REPORT_READ: 'yard_report.read',
} as const;

/**
 * Strict union type for all available permission keys.
 * Use this type in signatures to ensure compile-time safety.
 */
export type AppPermission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

/**
 * Array of all valid permission keys.
 */
export const ALL_PERMISSIONS = Object.values(PERMISSIONS);
